<h1>{{ job.name }}</h1>

<div class="row">

<div translate class="col-3">
  JOBS.DATASETS
  <div [vlist]="job.inputDatasets"></div>

  <button (click)="addDataset()">{{ 'JOBS.ADD_DS' | translate }}</button>
  <br/>
  <br/>
  JOBS.FOLDERS
  <div [vlist]="job.inputFolders"></div>
  <button (click)="addFolder()">{{ 'JOBS.ADD_FOLDER' | translate }}</button>

</div>
<div translate class="col-3">
  GENERIC.BATCHES
  <div [vlist]="batches"></div>

</div>
<div translate class="col-3">
  JOBS.OPERATIONS_ALLOWED
  <!--<div *ngIf="job.current">
    Currently running : {{ job.current.name }}
  </div>-->

  <!--<div *ngIf="!job.current && !initalTransform">
    No inital transform
    <button (click)="runXForm(job.jobType.baseTransform)">Run inital</button>
  </div>-->

 <!--<div *ngIf="!job.current && initalTransform">
    Inital xForm has been run
    <br/>
    following xforms allowed:
    <button (click)="runXForm(cur)" *ngFor="let cur of job.jobType.subTransforms.items | async">Run {{ cur.name }}</button>
    <br/>
    <br/>
    <hr/>
    Also, you can:
     <button (click)="runXForm(job.jobType.baseTransform)">Re-run initial</button>
  </div>-->



</div>

</div>
